// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectClosePositionMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
export class ClosePositionMessageProcessor extends MessageProcessorBase {
    constructor(parentDecoder) {
        super();
        this.decoder = parentDecoder;
    }
    decode(fieldSet) {
        const message = new DirectClosePositionMessage();
        // Open Order ID
        message.Id = fieldSet.GetValue(FieldsFactory.FIELD_POSITION_ID).toString();
        // Close price
        message.ClosePrice = fieldSet.GetValue(FieldsFactory.FIELD_PRICE);
        // Close time
        message.CloseTime = fieldSet.GetValue(FieldsFactory.FIELD_DATE);
        message.OrderWasManual = fieldSet.GetValue(FieldsFactory.FIELD_ORDER_IS_WAS_MANUAL);
        return [message];
    }
}
